import { BASE_PATH, LANG } from '../App/constants'

export const BONUS_STATUS_NEW = 'new'
export const BONUS_STATUS_ACTIVE = 'active'
export const BONUS_STATUS_QUEUED = 'queued'
export const BONUS_STATUS_PAID = 'paid'
export const BONUS_STATUS_CANCELED = 'canceled'

export const BONUSES_URL = `${BASE_PATH}/content-loader/${LANG}/payment/bonuses`
